// eslint-disable-next-line no-restricted-imports -- Required for Node.js script compatibility (routesMetadata.config.js)
import { TABLE_COL_NAMES } from './table-cell.const.js'

export const POLICY_TYPES = {
  ALLOW_LIST: 'allow-list',
  BLOCK_LIST: 'block-list',
}

export const POLICY_CONFIG = {
  [POLICY_TYPES.ALLOW_LIST]: {
    type: POLICY_TYPES.ALLOW_LIST,
    label: 'Allowed by policy',
    navLabel: 'Allowed products',
    icon: 'shield-check',
    color: 'positive',
    textColor: 'surface',
    description: 'These are the tools already trusted for your work - adopt them with confidence.',
    note: 'Allowed by policy - this request is auto-approved and added to your approvals after you fill in a few details.',
    actionLabel: 'Add to my approvals',
    actionAriaLabel: (productName) => `Add ${productName} to my approvals`,
    modalTitle: (productName) => `Add ${productName} to my approvals`,
    modalBody: (productName) =>
      `This request will be auto-approved. ${productName} will be added to your approvals after you fill in a few details on your intended use.`,
    metaDescription:
      'Products your organization allows by policy. These are the tools already trusted for your work - adopt them with confidence.',
  },
  [POLICY_TYPES.BLOCK_LIST]: {
    type: POLICY_TYPES.BLOCK_LIST,
    label: 'Blocked by policy',
    navLabel: 'Blocked products',
    icon: 'ban',
    color: 'negative',
    textColor: 'surface',
    description:
      "Knowing what's off-limits helps you choose tools that fit your organization's standards.",
    note: 'Blocked by policy - this request is auto-rejected, but you can still message the administrator from the request.',
    actionLabel: 'Submit for review',
    actionAriaLabel: (productName) => `Submit ${productName} for review`,
    modalTitle: (productName) => `Submit ${productName} for review`,
    modalBody: (productName) =>
      `This request will be auto-rejected. If you still need ${productName}, you can message the administrator from the rejected request for more details.`,
    metaDescription:
      "Products your organization blocks by policy. Knowing what's off-limits helps you choose tools that fit your organization's standards.",
  },
}

export const POLICY_FILTER_FIELDS = {
  search: '', // string
  status: POLICY_TYPES.ALLOW_LIST, // 'allow-list', 'block-list'
}

export const POLICY_SORT_PAGINATION_FIELDS = {
  sortBy: TABLE_COL_NAMES.COMPANY_NAME,
  descending: false,
  page: 1,
  rowsPerPage: 15,
}

export const DEFAULT_FILTER_SORT = {
  ...POLICY_SORT_PAGINATION_FIELDS,
  ...POLICY_FILTER_FIELDS,
}

// `navLabel` names the collection for the directory nav; `label` states the policy status
// and stays on the badge, the list heading and the document title.
export const POLICY_DIRECTORIES = Object.values(POLICY_CONFIG).map(({ type, navLabel, icon }) => ({
  id: type,
  label: navLabel,
  icon,
}))

export const POLICY_GROUP_BY = {
  PRODUCT: TABLE_COL_NAMES.PRODUCT_NAME,
  COMPANY: TABLE_COL_NAMES.COMPANY_NAME,
}

export const POLICY_GROUP_BY_OPTIONS = [
  { label: 'Product', value: POLICY_GROUP_BY.PRODUCT, icon: 'package' },
  { label: 'Company', value: POLICY_GROUP_BY.COMPANY, icon: 'building' },
]

export const POLICY_OWNED_STATES = {
  APPROVAL: 'approval',
  REQUEST: 'request',
}

export const POLICY_OWNED_CONFIG = {
  [POLICY_OWNED_STATES.APPROVAL]: {
    label: 'View my approval',
    actionAriaLabel: (productName) => `View my approval for ${productName}`,
    icon: 'badge-check',
    color: 'positive',
    textColor: 'surface',
  },
  [POLICY_OWNED_STATES.REQUEST]: {
    label: 'View my request',
    actionAriaLabel: (productName) => `View my request for ${productName}`,
    icon: 'clipboard-clock',
    color: 'info',
    textColor: 'primary',
  },
}

export const POLICY_COMPANY_ACTION = {
  label: 'Request a product',
  actionAriaLabel: (companyName) => `Request a product from ${companyName}`,
  icon: 'shield-plus',
  color: 'brand',
}

export const POLICY_COMPANY_VIEW_APPROVALS = {
  label: 'View my approvals',
  actionAriaLabel: (companyName) => `View my approvals at ${companyName}`,
  icon: 'badge-check',
  color: 'positive',
}

export const POLICY_COMPANY_VIEW_REQUESTS = {
  label: 'View my requests',
  actionAriaLabel: (companyName) => `View my requests at ${companyName}`,
  icon: 'clipboard-clock',
  color: 'info',
}
